import React from 'react';
import PropTypes from 'prop-types';
import './stepper.scss'

const Stepper = ({stepName, customClass, activeIndex = 1, steprAmount = 1}) => {
  return (
    <div className={`stepper ${customClass}`}>
      <div className="stepper-top">
        <div className="stepper-index">{activeIndex}</div>
        <div className="stepper-label">{stepName}</div>
      </div>
      <div className="stepper-steps">
        {[...Array(steprAmount)].map((_, i) =>
          <div key={i} className={`stepper-step${i + 1 === activeIndex ? ' active' : ''}`} />)}
        <div className={`stepper-finish${activeIndex === steprAmount ? ' active' : ''}`} />
      </div>
    </div>
  );
};

Stepper.propTypes = {
  stepName: PropTypes.string,
  customClass: PropTypes.string,
  activeIndex: PropTypes.number,
  steprAmount: PropTypes.number,
};

export default Stepper;
